import axiosClient from "../common/axios/axiosConfig";
import { formatDate, transformDateToType } from "../utils/date-util/dateUtils";
import { showToast } from "../utils/showToast";

interface IResponse {
	codigoProfessional: string;
	dataHora: string;
	idHorario: string;
	teleconsulta: boolean;
	convenio: string;
	procedimento: {
		_id: string;
		descricao: string;
	};
	valor: number;
}

export interface ISchedule {
	convenio: string;
	procedimento: {
		_id: string;
		descricao: string;
	};
	idHorario: string;
	hora: string;
	horarioInicial: string;
	telemedicina: boolean;
	valor: number;
}

export interface ISchedulesAvailable {
	date: string;
	schedules: ISchedule[];
}

interface GetSchedulesAvailableParams {
	dataInicial?: string;
	dataFinal?: string;
	procedureIds?: string[];
}

export const getSchedulesAvailable = async (codProfessional: string, params: GetSchedulesAvailableParams) => {
	try {
		const response = await axiosClient.get<IResponse[]>(`/listar-horarios/${codProfessional}`, {
			params: {
				dataInicial: params.dataInicial,
				dataFinal: params.dataFinal,
				procedureIds: JSON.stringify(params.procedureIds),
				insuranceName: window.sessionStorage.getItem("insuranceName") ?? '',
			},
		});

		const schedules = response.data;
		const formattedTimesAvailable: ISchedulesAvailable[] = [];

		if (schedules.length === 0) return formattedTimesAvailable;

		schedules.forEach((schedule) => {
			const scheduleDate = transformDateToType(schedule.dataHora);
			const scheduleDateISO = scheduleDate.set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISO();

			const newSchedule: ISchedule = {
				idHorario: schedule.idHorario,
				hora: formatDate("HH:mm", scheduleDate),
				horarioInicial: schedule.dataHora,
				telemedicina: schedule.teleconsulta,
				convenio: schedule.convenio,
				procedimento: schedule.procedimento,
				valor: schedule.valor,
			};

			const dateIndex = formattedTimesAvailable.findIndex((scheduleGroup) => {
				const dateTime = transformDateToType(scheduleGroup.date);

				return dateTime.toISODate() === scheduleDate.toISODate();
			});

			if (dateIndex === -1) {
				formattedTimesAvailable.push({
					date: scheduleDateISO,
					schedules: [newSchedule],
				});
			} else {
				formattedTimesAvailable[dateIndex].schedules.push(newSchedule);
			}
		});

		return formattedTimesAvailable;
	} catch (error) {
		showToast("error", {
			text: "Erro ao buscar horários disponíveis",
		});
		return [];
	}
};
